import { useEffect, useState } from 'react';
import { fetchAllPets } from '../service/petService';

const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllPets()
      .then((result) => {
        setProducts(result.products);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to fetch pets:', err);
        setLoading(false);
      });
  }, []);

  return [products, loading];
};

export default useProducts;